import React, {Fragment} from 'react';
import {Container, Row, Col} from 'reactstrap';
import '../sass/header.scss';
import {connect} from 'react-redux';
import Menu from '../components/menu';
import {Link} from 'react-router-dom';

interface propiedades {
  logo: string;
  token: string;
}

interface configObject {
  user: {
    token: string;
  };
  configReducer: {
    siteConfig: {
      styles: {
        logo: string;
      };
    };
  };
}

const Header = (props: propiedades) => {
  const {token, logo} = props;
  return (
    <Fragment>
      <header className="background-primary admin-header">
        <Container>
          <Row>
            <Col xs={8} md={2} className="pt-3">
              <Link to="/admin/home">
                {logo && <img src={logo} alt="" className="img-fluid" />}
              </Link>
            </Col>
            <Col xs={4} md={10} className="text-end">
              {token && <Menu />}
            </Col>
          </Row>
        </Container>
      </header>
    </Fragment>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
    logo: state.configReducer.siteConfig.styles.logo,
  };
};
export default connect(mapStateToProps)(Header);
